export const platformAdminIdentityCustomFields = {
  columns: {
    fieldKey: "Field Key",
    label: "Label",
    dataType: "Data Type",
    required: "Required",
    visibility: "Visibility",
    editability: "Editability",
    sortOrder: "Sort Order",
  },
  values: {
    archived: "Archived",
    visible: "Visible",
    hidden: "Hidden",
    editable: "Editable",
    readonly: "Read-only",
  },
  dataTypes: {
    text: "Single-line text",
    textarea: "Multi-line text",
    number: "Number",
    select: "Select",
    boolean: "Boolean",
    date: "Date",
  },
  actions: {
    createDefinition: "Create Field Definition",
    userValues: "User Custom Fields",
  },
  forms: {
    createTitle: "Create User Custom Field",
    editTitle: "Edit User Custom Field · {name}",
    fieldKey: "Field Key",
    label: "Label",
    dataType: "Data Type",
    required: "Required",
    visibility: "Visibility",
    editability: "Editability",
    sortOrder: "Sort Order",
    options: "Options",
    optionsText: "Options (one per line)",
    requiredField: "Please enter {label}",
    requiredFieldKey: "Please enter field key",
    requiredLabel: "Please enter label",
    requiredDataType: "Please select data type",
    requiredOptions: "Please enter one option per line",
  },
  drawers: {
    userValues: "User Custom Fields · {name}",
    userValuesShort: "User Custom Fields",
  },
  alerts: {
    userValues:
      "Custom field values are stored in unified identity user_profiles.custom_fields_json. Business apps read identity master data as needed.",
  },
  confirms: {
    archiveTitle: "Archive Field Definition",
  },
  messages: {
    loadUserValuesFailed: "Failed to load user custom fields",
    noTargetUser: "No target user selected",
    valuesSaved: "User custom fields saved",
    valuesSaveFailed: "Failed to save user custom fields",
    definitionCreated: "Field definition created",
    definitionCreateFailed: "Failed to create field definition",
    definitionUpdated: "Field definition updated",
    definitionUpdateFailed: "Failed to update field definition",
    definitionArchived: "Field definition archived",
    archivedReadonly:
      "Archived field definitions are audit-retained terminal records and cannot be edited or restored",
    definitionArchiveFailed: "Failed to archive field definition",
    noArchivableDefinitions: "No selected field definitions can be archived",
    batchDefinitionArchived: "Archived {count} field definitions",
    batchDefinitionArchivePartialFailed: "{count} field definitions still failed to archive",
  },
} as const;
